import {Text, View} from '@react-pdf/renderer';

import {PdfCultureTypeDescription} from './PdfCultureTypeDescription';
import {PdfMatchBar} from './PdfMatchBar';
import {CultureType} from '../../../../../culture/dashboard/types/CultureInformationTypes';
import {cultureTypeOverviewStyles as styles} from '../../styles/culture-type-overview';
import {sharedStyles} from '../../styles/shared-styles';

interface Props {
  matchPercentage?: string;
  cultureData?: CultureType;
  t: (key: string) => string;
  currentLanguage: 'en' | 'de';
}

export const PdfCultureTypeOverview = ({matchPercentage, cultureData, t, currentLanguage}: Props) => {
  return (
    <View style={styles.cultureTypeContainer}>
      <Text style={sharedStyles.h2}>{t('shared.cultureType')}</Text>
      <View style={styles.matchBox}>
        {matchPercentage && (
          <>
            <PdfMatchBar matchPercentage={matchPercentage} currentLanguage={currentLanguage} />{' '}
            <View style={{borderTop: '0.5px solid #315458'}} />
          </>
        )}
        <PdfCultureTypeDescription cultureData={cultureData} currentLanguage={currentLanguage} />
      </View>
    </View>
  );
};
